import React from "react";
import { MusicHallPaymentFormStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { portalService } from "apiServices";
import { PAYMENT_METHOD_ADMIN } from "utils/functions/musicHall";
import { Buttons, Inputs } from "components";

const MusicHallPaymentForm = ({ initialValues, onBack, onSubmit }) => {
  const schema = yup.object().shape({
    payment_method: yup.string().required("required"),
    transfer_amount: yup.number().typeError("must be a number"),
    slip_upload: yup.array().min(1, "Please upload at least 1 image"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });

  return (
    <MusicHallPaymentFormStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="f_tile">Payment Form</div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.Dropdown
                {...field}
                label={"รูปแบบการชำระเงิน"}
                options={PAYMENT_METHOD_ADMIN}
                // placeholder={t('test')}
                errors={errors.payment_method?.message}
              />
            )}
            name="payment_method"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                type="Number"
                label={"จำนวนเงิน"}
                // placeholder={t('test')}
                errors={errors.transfer_amount?.message}
              />
            )}
            name="transfer_amount"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.DateTimePicker
                {...field}
                theme_gray
                label={"วันที่ได้รับชำระเงิน"}
                // placeholder={t('test')}
                errors={errors.paid_at?.message}
              />
            )}
            name="paid_at"
            defaultValue=""
          />
        </div>
        <div className="input_wrap">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.UploadImageInput
                {...field}
                theme_upload_image
                label="รูปหลักฐานการชำระเงิน"
                acceptType={"cover"}
                uploadApiUrl={portalService.POST_ROOM_BOOKING_SLIP_UPLOAD_MEDIA}
                deleteApiUrl={portalService.PUT_ROOM_BOOKING_SLIP_IMG_DELETE}
                paramDelete={"slip_img_path"}
                id={initialValues._id}
                // scaleLabel="*** รูปขนาดไม่เก็น 8 MB"
                maxMBFileSizeWarning={10}
                maxFiles={5}
                errors={errors.slip_upload?.message}
              />
            )}
            name="slip_upload"
            defaultValue={[]}
          />
          <div className="note">
            * ต้อง upload รูปสลิปโอนเงิน หรือรูปสลิปบัตรเครดิต
            หรือใบสำคัญรับเงิน
          </div>
        </div>
        <div className="action_layout">
          <div className="btn_action_wrap">
            <Buttons.BgStandard theme_gray label="Cancle" onClick={onBack} />
          </div>
          <div className="btn_action_wrap">
            <Buttons.BgStandard theme_purple type="submit" label="Submit" />
          </div>
        </div>
      </form>
    </MusicHallPaymentFormStyled>
  );
};

MusicHallPaymentForm.propTypes = {};

export default MusicHallPaymentForm;
